import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  TextField,
  Typography,
  IconButton,
  Chip,
  InputAdornment,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Pause from "@mui/icons-material/Pause";
import { capitalize } from "lodash";
import AudioButton from "../../Components/Media/AudioButton";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import CircularProgress from "@mui/material/CircularProgress";

import { getWordsByPagination } from "./Services";
import { unicodeToString } from "../../Js/Common";

//const languages = ["English", "French", "Hindi", "Sanskrit"];
let languages = ["English", "French"];

const Vocabulary = (props) => {
  const classes = useStyles();
  const listInnerRef = useRef();
  const paginationVal = 10;

  // Hooks
  const dispatch = useDispatch();

  // State
  const [languageList, setLanguageList] = useState(languages);
  const [words, setWords] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [currentWord, setCurrentWord] = useState(null);
  const [currentPOS, setCurrentPOS] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);

  useEffect(() => {
    if (siteConfig) {
      let temparray = [...languages];
      console.log("siteConfig", siteConfig);
      if (siteConfig?.customer?.addOnInfo?.isDefence) {
        temparray.push("Defence");
      } else {
        const index = temparray.indexOf("Defence");
        if (index > -1) {
          // only splice array when item is found
          temparray.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      setLanguageList(temparray);
    }
  }, [siteConfig]);

  const handleChange = (event) => {
    console.log(":S:S:S", event.target.value);
    setIsLoading(true);
    setSelectedLanguage(event.target.value);
  };

  useEffect(() => {
    const getData = setTimeout(async () => {
      setCurrentPage(1);
      setTotalData(0);
      setWords([]);
      if (searchString && searchString.trim().length > 0) {
        fetchWords(1);
      }
      if (searchString.trim().length == 0) {
        setIsLoading(false);
        setCurrentWord(null);
      }
    }, 2000);

    return () => clearTimeout(getData);
  }, [searchString, selectedLanguage]);

  // Fetch Words Data
  const fetchWords = async (page) => {
    console.log("currentPage", currentPage);
    console.log("searchString", searchString);
    console.log("selectedLanguage", selectedLanguage);
    let wordsData = await getWordsByPagination(
      searchString,
      selectedLanguage,
      page
    );
    console.log("wordsData", wordsData);
    setIsFetching(false);
    dispatch(commonSliceActions.setLoader(false));
    if (page == 1) {
      setTotalData(wordsData.data.total);
      setWords(wordsData.data.data);
      setCurrentWord(null);
    } else {
      let newData = [...words, ...wordsData.data.data];
      setWords(newData);
    }
    setIsLoading(false);
  };

  const loadMore = () => {
    setCurrentPage((val) => val + 1);
    fetchWords(currentPage + 1);
  };

  const currentWordSelection = (obj) => {
    let tempObj = {
      ...obj,
      content:
        typeof obj.content == "string" ? JSON.parse(obj.content) : obj.content,
    };
    console.log("tempObj", tempObj);
    setCurrentWord(tempObj);
  };

  return (
    <>
      <Grid container gap={1} justifyContent={"space-around"} mt={2}>
        <Grid item sm={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Language</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              defaultValue={"English"}
              value={selectedLanguage}
              label="Language"
              onChange={handleChange}
            >
              {languageList &&
                languageList.length > 0 &&
                languageList.map((val, index) => {
                  return <MenuItem value={val}>{val}</MenuItem>;
                })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={8}>
          <TextField
            id="search"
            tabIndex={0}
            placeholder="Search..."
            variant="outlined"
            fullWidth
            value={searchString}
            //   onBlur={() => {
            //     nameBlurValidate();
            //   }}
            onInput={(event) => {
              setIsLoading(true);
              setSearchString(event.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {isLoading && <CircularProgress size={25}></CircularProgress>}
                </InputAdornment>
              ),
            }}
            //   value={name}
            //   helperText={nameError}
            //   error={nameError != null}
            // onKeyDown={(event) => {
            //   if (event.keyCode === 13) {
            //     validateCredentials();
            //   }
            // }}
          />
        </Grid>
        <Grid
          item
          sm={3}
          sx={{ border: 1, borderRadius: 2, borderColor: "#CCCCCC" }}
        >
          <Box
             
            sx={{ height: "62vh", overflow: "auto" }}
            ref={listInnerRef}
            // onScroll={() => {
            //   if (handleInfinityScroll()) {
            //     handleLoadMore();
            //   }
            // }}
          >
            <List>
              {words &&
                words.length > 0 &&
                words.map((word) => {
                  return (
                    <ListItem
                      disablePadding
                      sx={{
                        backgroundColor:
                          word.uid == currentWord?.uid ? "#d9dffc" : "#FFFFFF",
                        color:
                          word.uid == currentWord?.uid ? "#DB8829" : "#000000",
                      }}
                    >
                      <ListItemButton
                        onClick={() => {
                          currentWordSelection(word);
                        }}
                      >
                        <ListItemText
                          primary={word.word_phrase}
                          primaryTypographyProps={{
                            fontWeight:
                              word.uid == currentWord?.uid ? "bold" : "300",
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              {((words && words.length == 0) || !words) &&
                searchString &&
                !isLoading && (
                  <ListItem
                    disablePadding
                    sx={{
                      backgroundColor: "#FFFFFF",
                      color: "#CCCCCC",
                    }}
                  >
                    <ListItemButton>
                      <ListItemText primary={"No word found"} />
                    </ListItemButton>
                  </ListItem>
                )}
              {words && words.length < totalData && (
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={loadMore}
                    sx={{
                      textTransform: "inherit",
                      borderRadius: 10,
                      boxShadow: 3,
                      fontWeight: "600",
                      fontSize: "1rem",
                      mx: 1,
                      backgroundColor: "primary.main",
                      color: "#FFF",
                      textAlign: "center",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                     
                    }}
                    dense
                  >
                    <ListItemText primary={"Load More"} />
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Box>
        </Grid>
        <Grid
          item
          sm={8}
          sx={{ border: 1, borderRadius: 2, borderColor: "#CCCCCC" }}
        >
          {currentWord && (
            <Box sx={{ height: "58vh" }}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  flexFlow: "wrap",
                  justifyContent: "center",
                }}
              >
                <Grid item xs={12}>
                  <Box sx={{ paddingTop: 0 }}>
                    <Grid
                      container
                      sx={{
                        flexDirection: "row",
                        mt: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        height: "15vh",
                        backgroundColor: "#F5F7FF",
                      }}
                    >
                      <Grid item xs={1}></Grid>
                      <Grid
                        item
                        xs={10}
                        sx={{
                          position: "relative",
                          cursor: "pointer",
                          py: 4,
                          textAlign: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "15vh",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            textAlign: "center",
                            justifyContent: "center",
                            alignContent: "center",
                            position: "relative",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "primary.main",
                              fontSize: "2rem",
                              fontWeight: "700",
                              "@media (min-width: 1636px)": {
                                fontSize: "4rem",
                              },
                            }}
                          >
                            {currentWord.word_phrase
                              ? currentWord.word_phrase
                              : ""}{" "}
                            |
                          </Typography>
                          <Typography
                            sx={{
                              color: "primary.main",
                              "@media (min-width: 1636px)": {
                                fontSize: "2rem",
                              },
                            }}
                          >
                            <sup>
                              CEFR{" "}
                              {currentWord.content &&
                              currentWord.content[0] &&
                              currentWord.content[0]["cefr_level"]
                                ? currentWord.content[0]["cefr_level"]
                                : ""}
                            </sup>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            position: "absolute",
                            top: "80%",
                            left: "40%",
                            // left: smartCheckResult ? "28%" : "33%",
                            // transform: "translatey(50%)",
                            // transform: "translateX(50%)",
                            // "@media (min-width: 1636px)": {
                            //   left: smartCheckResult ? "39.5%" : "41.5%",
                            // },
                          }}
                        >
                          {currentWord.content &&
                            currentWord.content[0] &&
                            currentWord.content[0]["media"] &&
                            currentWord.content[0]["media"]["audio"] && (
                              <>
                                <AudioButton
                                  wordAudio={
                                    currentWord.content[currentPOS]["media"][
                                      "audio"
                                    ]
                                  }
                                  playStatus={(status) => setIsPlaying(status)}
                                >
                                  <IconButton
                                    sx={{
                                      mx: 1,
                                      border: 1,
                                      borderColor: "#EFEFEF",
                                      backgroundColor: "#FFFFFF",
                                      boxShadow: 2,
                                      color: "primary.main",
                                     
                                    }}
                                  >
                                    {isPlaying ? (
                                      <Pause
                                        sx={{
                                          "@media (min-width: 1636px)": {
                                            fontSize: "2rem",
                                          },
                                        }}
                                      />
                                    ) : (
                                      <PlayArrowIcon
                                        sx={{
                                          "@media (min-width: 1636px)": {
                                            fontSize: "2rem",
                                          },
                                        }}
                                      />
                                    )}
                                  </IconButton>
                                </AudioButton>
                              </>
                            )}
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        sx={{
                          "@media (min-width: 1636px)": {
                            textAlign: "right",
                            pr: 3,
                          },
                        }}
                      ></Grid>
                    </Grid>
                  </Box>
                  <Box sx={{ pa: 0 }}>
                    <Grid
                       
                      container
                      sx={{
                        height: "36vh",
                        mt: 4,
                        overflow: "auto",
                        "@media (min-width: 1636px)": {
                          height: "38vh",
                        },
                      }}
                    >
                      <Grid item xs={12} textAlign={"center"}>
                        {currentWord.content &&
                          currentWord.content[currentPOS] &&
                          currentWord.content.map((val, posindex) => {
                            return (
                              <Chip
                                label={capitalize(unicodeToString(val.pos))}
                                component="a"
                                clickable
                                color="primary"
                                variant={
                                  posindex == currentPOS
                                    ? "contain"
                                    : "outlined"
                                }
                                onClick={() => setCurrentPOS(posindex)}
                                sx={{
                                  ml: 1,
                                  fontSize: "0.7rem",
                                  fontWeight: "600",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1rem",
                                  },
                                }}
                              />
                            );
                          })}
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container sx={{ mt: 1 }}>
                          <Grid
                            item
                            xs={4}
                             
                            sx={{
                              textAlign: "center",
                              borderRight: 1,
                              borderColor: "#EAECEE",
                              width: "100%",
                              backgroundColor: "#FFF",
                            }}
                          >
                            {currentWord.content &&
                              currentWord.content[currentPOS] &&
                              currentWord.content[currentPOS]["media"] &&
                              currentWord.content[currentPOS]["media"][
                                "image"
                              ] && (
                                <img
                                  src={`${sessionStorage.getItem(
                                    "media_url"
                                  )}words_media/image/${
                                    currentWord.content[currentPOS]["media"][
                                      "image"
                                    ]
                                  }`}
                                  width="85%"
                                  style={{ borderRadius: 10 }}
                                />
                              )}
                          </Grid>
                          <Grid
                            item
                            xs={8}
                             
                            sx={{
                              height: "26vh",
                              overflow: "auto",
                              pl: 3,
                              "@media (min-width: 1636px)": {
                                height: "28vh",
                              },
                            }}
                          >
                            {currentWord.content &&
                              currentWord.content[currentPOS] &&
                              currentWord.content[currentPOS]["items"] &&
                              currentWord.content[currentPOS]["items"].map(
                                (item, index1) => {
                                  return (
                                    <>
                                      <Typography
                                        sx={{
                                          color: "primary.main",
                                          fontWeight: "700",
                                          fontSize: "0.9rem",
                                          mt: index1 > 0 ? 2 : 0,
                                          "@media (min-width: 1636px)": {
                                            fontSize: "1.6rem",
                                          },
                                        }}
                                        key={`${index1}_item`}
                                      >
                                        {item.title
                                          ? unicodeToString(item.title)
                                          : ""}
                                      </Typography>
                                      {item.list &&
                                        item.list.map((textObj, index2) => {
                                          return (
                                            <Typography
                                              sx={{
                                                color: "primary.main",
                                                fontWeight: "500",
                                                fontSize: "0.9rem",
                                                "@media (min-width: 1636px)": {
                                                  fontSize: "1.4rem",
                                                },
                                              }}
                                            >
                                              {textObj.text
                                                ? unicodeToString(textObj.text)
                                                : ""}
                                            </Typography>
                                          );
                                        })}
                                    </>
                                  );
                                }
                              )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default Vocabulary;
